import { Plugin } from 'vue'
import strings from './dd-strings.strings'

export default {
  install(app) {
    app.config.globalProperties.$strings = strings
  },
} as Plugin
